import React from 'react';
import Card from '../ui/Card/Card';
import Typography from '../ui/Typography/Typography';
import Stack, { HStack } from '../ui/Stack/Stack';

const LinkageStatistics = ({ statistics }) => {
  if (!statistics || typeof statistics !== 'object' || Object.keys(statistics).length === 0) {
    return null;
  }

  const summaryItems = [
    { label: "Total Records in Final Linked Output", value: statistics.linked_records_count },
    { label: "Total Unique Individuals (Hashed_IDs)", value: statistics.union_hashed_ids },
    { label: "Individuals Present in ALL Processed Sources", value: statistics.fully_matched_records_all_sources },
  ];

  const matchesBySource = statistics.matches_by_source_count ? 
    Object.entries(statistics.matches_by_source_count).sort(([a], [b]) => parseInt(a) - parseInt(b)) : [];

  return (
    <Card title="Latest Linkage Statistics" elevation="sm">
      <Stack p="md" spacing="lg">
        <Card elevation="sm" style={{backgroundColor: 'var(--cipher-color-background-page)'}} title="Overall Summary">
          <Stack spacing="sm" p="md">
            {summaryItems.map(item => item.value !== undefined && (
              <HStack key={item.label} justifyContent="space-between">
                <Typography>{item.label}:</Typography>
                <Typography fontWeight="semibold">{item.value}</Typography>
              </HStack>
            ))}
          </Stack>
        </Card>

        {matchesBySource.length > 0 && (
          <Card elevation="sm" style={{backgroundColor: 'var(--cipher-color-background-page)'}} title="Record Distribution by Sources Matched">
            <Stack spacing="sm" p="md">
              {matchesBySource.map(([numSources, count]) => (
                <HStack key={numSources} justifyContent="space-between">
                  <Typography>Matched in {numSources} source(s):</Typography>
                  <Typography fontWeight="semibold">{count} records</Typography>
                </HStack>
              ))}
            </Stack>
          </Card>
        )}
      </Stack>
    </Card>
  );
};

export default LinkageStatistics;